<template>
  <div class="product-gallery">
    <!-- Основной слайдер -->
    <Swiper
      class="gallery-main"
      :modules="modules"
      :space-between="10"
      :navigation="false"
      :keyboard="{ enabled: true }"
      :thumbs="{ swiper: thumbsSwiper }"
      @slideChange="onSlideChange"
    >
      <SwiperSlide v-for="(url, i) in normalized" :key="i" class="swiperSlide">
        <img
          :src="url"
          :alt="altText(i)"
          loading="lazy"
          @click="$emit('open', i)"
        />
      </SwiperSlide>
    </Swiper>

    <!-- Превью -->
    <Swiper
      class="gallery-thumbs"
      :modules="modules"
      :space-between="6"
      :slides-per-view="'auto'"
      :watch-slides-progress="true"
      :free-mode="true"
      :onSwiper="setThumbsSwiper"
    >
      <SwiperSlide v-for="(url, i) in normalized" :key="'t' + i">
        <img :src="url" :alt="altText(i)" loading="lazy" />
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue"
import { Thumbs, FreeMode, Keyboard } from "swiper/modules"
import "swiper/css"
import "swiper/css/free-mode"
import "swiper/css/thumbs"

export default {
  name: "ProductGallerySimple",
  components: { Swiper, SwiperSlide },
  props: {
    images: { type: Array, required: true },
    altBase: { type: String, default: "Фото товара" },
  },
  data() {
    return {
      modules: [Thumbs, FreeMode, Keyboard],
      thumbsSwiper: null,
      currentIndex: 0,
      size: { w: 0, h: 0 },
    }
  },
  computed: {
    normalized() {
      return this.images.map((i) => (typeof i === "string" ? i : i.src))
    },
    normalizedWithAlt() {
      return this.images.map((i, idx) =>
        typeof i === "string"
          ? { src: i, alt: this.altText(idx) }
          : { src: i.src, alt: i.alt || this.altText(idx) }
      )
    },
  },
  watch: {
    images: {
      immediate: true,
      handler() {
        this.measureFirstImage()
      },
    },
  },
  methods: {
    setThumbsSwiper(swiper) {
      this.thumbsSwiper = swiper
    },
    onSlideChange(swiper) {
      this.currentIndex = swiper.activeIndex
      this.$emit("slideChange", swiper.activeIndex)
    },
    altText(i) {
      return `${this.altBase} ${i + 1}`
    },
    async measureFirstImage() {
      if (!this.normalized.length) return
      try {
        const dim = await this.loadDims(this.normalized[0])
        this.size = { w: dim.w, h: dim.h }
      } catch {
        this.size = { w: 1600, h: 1200 }
      }
    },
    loadDims(src) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () =>
          resolve({ w: img.naturalWidth, h: img.naturalHeight })
        img.onerror = reject
        img.src = src
      })
    },
  },
}
</script>

<style scoped lang="scss">
.product-gallery {
  width: 100%;
  img {
    transform: scale(-1, 1);
  }
}
.gallery-main {
  margin-bottom: 0.25rem;
  height: 20rem !important;
  .swiperSlide {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.gallery-main img {
  width: 90%;
  display: block;
  object-fit: contain;
  user-select: none;
}
.main-image-link {
  display: block;
  height: 17.75rem;
}
.main-image-link img {
  height: 100%;
}

/* Превью */
.gallery-thumbs {
  width: 90%;
}
.gallery-thumbs .swiper-slide {
  width: 5.25rem !important;
  height: 5.25rem;
  cursor: pointer;
  opacity: 0.8;
  overflow: hidden;
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.gallery-thumbs .swiper-slide-thumb-active {
  opacity: 1;
  border-bottom: 0.125rem solid #1d1d1b;
}
.gallery-thumbs img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}
</style>

<style>
.pswp__img {
  object-fit: contain;
}
</style>
